var map = {
	"./Mega Discount.svg": "b202",
	"./bidding-icon.svg": "c638",
	"./bidding.svg": "73ca",
	"./crowns.svg": "95fd",
	"./cuttheprice.png": "50df",
	"./gems.svg": "4aa7",
	"./ic_medal.svg": "1a0e",
	"./ic_new.svg": "aa9e",
	"./m-cash.svg": "c2f8",
	"./oye-lucky.png": "9217",
	"./share_and_Earn.jpg": "4782",
	"./share_and_Earn.png": "86d2",
	"./shopping-bag.png": "5b41",
	"./view.svg": "8472",
	"./whatsapp.svg": "9436"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eba2";